<template>
  <div class="StopStation">
    <van-row class="white">
      <van-col :span="8">
        <h5 class="font16">
          {{ detail.fromStationName }}
          <van-tag
            v-if="detail.isStartStation"
            color="#eb852b"
          >
            始
          </van-tag>
          <van-tag
            v-if="detail.isStartStation === false"
            color="#3b94ea"
          >
            过
          </van-tag>
        </h5>
        <h3 class="font24">
          {{ detail.startTime }}
        </h3>
        <p>{{ detail.byTrainMonDay }} {{ detail.byTrainWeek }}</p>
      </van-col>

      <van-col
        :span="8"
        class="text-center trainNo font12"
        :class="trainNoClass"
      >
        <span>{{ detail.trainCode }}</span>
        <div
          class="stationIcon"
          @click="getStation"
        >
          经停站
        </div>
        <span>{{ detail.runMinute || detail.travelTime | filterTime }}</span>
      </van-col>

      <van-col
        :span="8" 
        class="text-right"
      >
        <h5 class="font16">
          {{ detail.toStationName }}
          <van-tag
            v-if="detail.isEndStation"
            color="#369f40"
          >
            终
          </van-tag>
          <van-tag
            v-if="detail.isEndStation === false"
            color="#3b94ea"
          >
            过
          </van-tag>
        </h5>
        <h3 class="font24">
          {{ detail.arriveTime }}
        </h3>
        <p>{{ detail.arriveDayMonDay }} {{ detail.arriveDayWeek }}</p>
      </van-col>
    </van-row>

    <!-- 经停时刻表 -->
    <van-popup
      v-model="stopPopup"
      class="StopStation text-center"
      :get-container="getContainer"
      :close-on-popstate="true"
      :style="{ width: '80%' }"
    >
      <van-row>
        <h3>
          经停时刻表
        </h3>
      </van-row>
      <van-row class="main-color">
        <van-col :span="6">
          车站
        </van-col>
        <van-col :span="6">
          到达
        </van-col>
        <van-col :span="6">
          发车
        </van-col>
        <van-col :span="6">
          停留
        </van-col>
      </van-row>

      <div
        class="stop-list-content"
        v-if="stationList.length > 0"
      >
        <van-row
          v-for="(station, index) in stationList"
          :key="station.stationNo"
          :class="{ 'gray': !station.isOverHere, 'main-color': station.active }"
        >
          <van-col
            :span="6"
            class="text-left"
          >
            {{ station.stationName }}
          </van-col>
          <van-col :span="6">
            {{ station.arriveTime }}
          </van-col>
          <van-col :span="6">
            {{ station.startTime }}
          </van-col>

          <van-col
            :span="6"
            v-if="index === 0"
          >
            始发
          </van-col>
          <van-col
            :span="6"
            v-else-if="index === stationList.length - 1"
          >
            终点
          </van-col>
          <van-col
            :span="6"
            v-else
          >
            {{ station.stopOverTime }}
          </van-col>
        </van-row>
      </div>
      <van-row v-else>
        没有查询到相关站点
      </van-row>
    </van-popup>
  </div>
</template>

<script>
import { Switch, Tabbar, TabbarItem, Popup, Tag } from 'vant'
import { formatDate } from 'Utils/dateUtil'

export default {
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Switch.name]: Switch,
    [Popup.name]: Popup,
    [Tag.name]: Tag,
  },
  props: {
    detail: {
      type: Object,
      default: () => {}
    },
    trainNoClass: String
  },
  data() {
    return {
      stopPopup: false,
      stationList: [],
      isDetail: false
    }
  },
  created() {
    this.init()
  },
  methods: {
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      return document.querySelector('.trEdit') || ''
    },
    init() {
      /**
			 * 字段转换 订单详 ———> 预订流程
			 */
      this.isDetail = !this.detail.byTrainDate // 没有该字段则是订单详情页面
      if (this.isDetail) {
        this.detail.byTrainDate = this.detail.fromDate
        this.detail.startTime = this.detail.fromTime
        this.detail.arriveTime = this.detail.toTime
        this.detail.runTime = this.detail.travelTime
      }

      /**
			 * 转换出发到达时间格式
			 * 预订流程页面 出发时间取 byTrainDate，       订单详情页面取 fromDate
			 *             到达时间根据 byTrainDate, arriveDays 计算， 订单详情页面取 toDate
			 */

      let depart = formatDate(this.detail.byTrainDate)
      let arrive = !this.isDetail
        ? formatDate(this.detail.byTrainDate, this.detail.arriveDays)
        : formatDate(this.detail.toDate || this.detail.fromDate)

      this.detail.byTrainMonDay = depart.monDay
      this.detail.byTrainWeek = depart.week
      this.detail.arriveDayMonDay = arrive.monDay
      this.detail.arriveDayWeek = arrive.week
    },
    // 展示经停站点
    getStation() {
      if (this.detail.trainNo && this.stationList.length === 0) {
        this.$api['trQuery/queryStation'](this.detail).then(res => {
          this.stopPopup = true
          if (res.data) this.stationList = this.filterStopStation(res.data.data)
        })
      } else {
        this.stopPopup = true
      }
    },
    /**
		 * 判断该当前选择行程在整个车次中的经过站点
		 * 比如 买广州南到虎门的车票，该躺车次的终点站深圳会置灰
		 */
    filterStopStation(stopList) {
      let minIndex, maxIndex

      stopList.forEach((station, i) => {
        if (
          station.stationName === this.detail.fromStationName ||
					station.stationName === this.detail.toStationName
        ) {
          station.active = true
          if (typeof minIndex === 'number') {
            maxIndex = i
          } else {
            minIndex = i
          }
        }
      })

      stopList.map((station, i) => {
        if (i < minIndex || i > maxIndex) {
          station.isOverHere = false
        } else {
          station.isOverHere = true
        }
      })
      return stopList
    }
  },
  filters: {
    filterTime(num) {
      num = Number(num)
      if (!isNaN(num)) {
        num = Math.abs(num)
        var shi = Math.floor(num / 60)
        var fen = num % 60
        var shiStr = shi < 10 ? '0' + shi : shi
        var fenStr = fen < 10 ? '0' + fen : fen
        if (shi == 0) {
          return fen + '分钟'
        } else if (shi > 0 && fen == 0) {
          return shiStr + '小时'
        } else if (shi > 0 && fen != 0) {
          return shiStr + '小时' + fenStr + '分钟'
        }
      }
    }
  },
  watch: {
    detail() {
      this.init()
    }
  }
}
</script>

<style lang="less">
.StopStation {
  h3,
  h5,
  p {
    margin: 1px 0;
  }

  padding: 5px 14px 20px;

  .trainNo {
    padding-top: 5px;

    .stationIcon {
      position: relative;
      width: 53px;
      margin: 2px auto;
      border: 1px solid;
      border-radius: @border-radius-lg;

      &:before,
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        width: 50%;
        border-bottom: 1px solid;
      }
      /*调整背景横线的左右距离*/
      &:before {
        left: -50%;
      }
      &:after {
        right: -50%;
      }
    }
  }

  .stop-list-content {
    height: 60vh;
    overflow-y: scroll;
  }

  .van-row {
    padding: 5px 15px;
  }
}
</style>
